module.exports = __webpack_public_path__ + "img/leave.5b9e2949.png";